import { useGetNews } from "../services/newService";
import { usePaginatedResource } from "../../../shared/hooks/usePaginatedResource";
import { DEFAULT_PAGE_SIZE } from "../../../shared/constants/pagination";
import { useAuthStore } from "../../../store";

export const useNewsResource = () => {
  const { user } = useAuthStore();
  const buildingId = user?.buildingId;
  const lifeguardId = user?.id;
  const {
    page,
    pageSize,
    handlePageChange,
    handlePageSizeChange,
  } = usePaginatedResource({
    initialFilters: {},
    initialPageSize: DEFAULT_PAGE_SIZE,
  });

  const {
    data: news,
    isLoading,
    isError,
    refetch,
  } = useGetNews({
    page,
    page_size: pageSize,
    // Always apply building_id and lifeguard_id from user context
    // These cannot be changed by the user via filters
    building_id: buildingId || undefined,
    lifeguard_id: lifeguardId || undefined,
  });

  return {
    data: news,
    isLoading,
    isError,
    page,
    pageSize,
    handlePageChange,
    handlePageSizeChange,
    refetch,
  };
};

